/*
 * @Author: RYL
 * @Description: 监控大屏系统总览接口
 * @Date: 2020-12-18 14:55:12
 * @LastEditTime: 2021-01-22 16:19:34
 */

import http from '@/axios/http'

// 获取设备概况
export function getDeviceStatistics() {
  return http({
    url:'/api2/device/statistics',
    method: 'post'
  })
}

// 获取今日报警统计
export function getAlarmStatistics() {
  return http({
    url:'/api2/alarmRecord/statistics',
    method: 'post'
  })
}

// 获取今日报警信息
export function getAlarmInfo() {
  return http({
    url:'/api2/alarmRecord/today/list',
    method: 'post'
  })
}


